// The current script
// document.addEventListener("DOMContentLoaded", function () {
//   const customRollRadio = document.querySelector('input[value="Custom Roll"]');
//   const standardRollRadio = document.querySelector('input[value="Standard Roll"]');
  

//   const calculatorHTML = `
//     <div id="entangle_floor_calculator_container">
//       <div class="entangle-cal-flooring" id="entangle_floor_calculator" style="display: block;">
//         <div style="color: #000000; background-color: #ffffff; border-radius: 10px; padding:10px;">
//           <div class="entangle-lw-container" style="padding-block:10px;">
//             <div class="entangle-lw-calculator-inputs" style="justify-content: normal;">
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="length" id="sqFtInput-length" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Length">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Length</span>
//               </div>
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="width" id="sqFtInput-width" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Width">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Width</span>
//               </div>
//             </div>
//             <div class="entangle-pc-heading">
//               <div></div>
//               <svg viewBox="0 0 20 20" height="20px" width="20px" style="fill: #008000;" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fill-rule="evenodd" d="M10 7.25c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 1 1 3.758 2.56.61.61 0 0 0-.226.147.154.154 0 0 0-.032.046.75.75 0 0 1-1.5-.003c0-.865.696-1.385 1.208-1.586a1.25 1.25 0 0 0-.458-2.414Z"></path><path d="M10 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg>
//             </div>
//             <div style="display: flex;flex-direction: column;line-height: 1.5;">
//               <p id="entanglePerBoxCoverage" style="margin: 0; font-size: 14px; font-weight: 650;">Per Unit Coverage: 1 in²</p>
//               <p id="entangleTotalPrice" style="margin: 0; font-size: 14px; font-weight: 650; color: #008000;">Total Price: </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;

//   let calculatorInserted = false;

//   function insertCalculatorIfNeeded() {
//     const existingCalculator = document.querySelector('#entangle_floor_calculator_container');
//     const fieldset = customRollRadio?.closest('fieldset');

//     if (standardRollRadio?.checked && existingCalculator) {
//       existingCalculator.remove();
//       calculatorInserted = false;
//       return;
//     }

//     if (customRollRadio?.checked && !calculatorInserted && fieldset) {
//       const tempWrapper = document.createElement('div');
//       tempWrapper.innerHTML = calculatorHTML;
//       const calculatorDiv = tempWrapper.firstElementChild;

//       fieldset.insertAdjacentElement('afterend', calculatorDiv);
//       calculatorInserted = true;

//       // Inject inline script for logic variables
//       const inlineScript = document.createElement("script");
//       inlineScript.textContent = `
//         const api_url = '/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/7468741427282';
//         let productHandle = 'windsor-scroll-damask-wallpaper';
//         let product_price;
//         let fc_variant_price = [{"id":42086459605074,"title":"Canvas / Standard Roll","option1":"Canvas","option2":"Standard Roll","price":3000},{"id":42111584600146,"title":"Canvas / Custom Roll","option1":"Canvas","option2":"Custom Roll","price":9500},{"id":42086459637842,"title":"Self Adhesive / Standard Roll","option1":"Self Adhesive","option2":"Standard Roll","price":4000},{"id":42111584632914,"title":"Self Adhesive / Custom Roll","option1":"Self Adhesive","option2":"Custom Roll","price":9500}];
//         var variantsIdSelected = fc_variant_price[0]?.id;
//       `;
//       document.body.appendChild(inlineScript);

//       // Load external calculator script
//       const externalScript = document.createElement("script");
//       externalScript.src = "https://cdn.shopify.com/extensions/31fb2947-9a15-47d8-bf6c-644ea8937ef1/price-calculator-79/assets/flooring.min.js";
//       externalScript.async = true;
//       document.body.appendChild(externalScript);
//     }
//   }

//   if (customRollRadio && standardRollRadio) {
//     customRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     standardRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     insertCalculatorIfNeeded(); // Run once on load
//   }
// });

//Script to show calculator when both standard roll and custom roll are in the options

//without warning msg
// document.addEventListener("DOMContentLoaded", function () {
//   const customRollRadio = document.querySelector('input[value="Custom Roll"]');
//   const standardRollRadio = document.querySelector('input[value="Standard Roll"]');

//   const calculatorHTML = `
//     <div id="entangle_floor_calculator_container">
//       <div class="entangle-cal-flooring" id="entangle_floor_calculator" style="display: block;">
//         <div style="color: #000000; background-color: #ffffff; border-radius: 10px; padding:10px;">
//           <div class="entangle-lw-container" style="padding-block:10px;">
//             <div class="entangle-lw-calculator-inputs" style="justify-content: normal;">
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="length" id="sqFtInput-length" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Length">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Length</span>
//               </div>
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="width" id="sqFtInput-width" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Width">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Width</span>
//               </div>
//             </div>
//             <div class="entangle-pc-heading">
//               <div></div>
//               <svg viewBox="0 0 20 20" height="20px" width="20px" style="fill: #008000;" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fill-rule="evenodd" d="M10 7.25c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 1 1 3.758 2.56.61.61 0 0 0-.226.147.154.154 0 0 0-.032.046.75.75 0 0 1-1.5-.003c0-.865.696-1.385 1.208-1.586a1.25 1.25 0 0 0-.458-2.414Z"></path><path d="M10 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg>
//             </div>
//             <div style="display: flex;flex-direction: column;line-height: 1.5;">
//               <p id="entanglePerBoxCoverage" style="margin: 0; font-size: 14px; font-weight: 650;">Per Unit Coverage: 1 in²</p>
//               <p id="entangleTotalPrice" style="margin: 0; font-size: 14px; font-weight: 650; color: #008000;">Total Price: </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;

//   let calculatorInserted = false;

//   function insertCalculatorIfNeeded() {
//     const existingCalculator = document.querySelector('#entangle_floor_calculator_container');
//     const fieldset = customRollRadio?.closest('fieldset');
//     const dimensionsNoteDiv = document.querySelector('.dimensions-note');
    
//     // Select the other #entangle_floor_calculator_container (the one already in DOM with your big HTML)
//     // We will call it originalCalculatorContainer to distinguish
//     const originalCalculatorContainer = document.querySelector('#entangle_floor_calculator_container:not(:empty):not([data-inserted])');

//     // Hide the originalCalculatorContainer on both selections
//     if (originalCalculatorContainer) {
//       originalCalculatorContainer.style.display = 'none';
//     }

//     if (standardRollRadio?.checked) {
//       if (existingCalculator) {
//         existingCalculator.remove();
//         calculatorInserted = false;
//       }
//       if (dimensionsNoteDiv) {
//         dimensionsNoteDiv.style.display = ''; // Show when Standard Roll selected
//       }
//       // originalCalculatorContainer is hidden already above
//       return;
//     }

//     if (customRollRadio?.checked) {
//       if (fieldset && !calculatorInserted) {
//         const tempWrapper = document.createElement('div');
//         tempWrapper.innerHTML = calculatorHTML;
//         const calculatorDiv = tempWrapper.firstElementChild;
//         calculatorDiv.setAttribute('data-inserted', 'true'); // mark as inserted to distinguish

//         fieldset.insertAdjacentElement('afterend', calculatorDiv);
//         calculatorInserted = true;

//         // Inject inline script for logic variables
//         const inlineScript = document.createElement("script");
//         inlineScript.textContent = `
//           const api_url = '/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/7468741427282';
//           let productHandle = 'windsor-scroll-damask-wallpaper';
//           let product_price;
//           let fc_variant_price = [{"id":42086459605074,"title":"Canvas / Standard Roll","option1":"Canvas","option2":"Standard Roll","price":3000},{"id":42111584600146,"title":"Canvas / Custom Roll","option1":"Canvas","option2":"Custom Roll","price":9500},{"id":42086459637842,"title":"Self Adhesive / Standard Roll","option1":"Self Adhesive","option2":"Standard Roll","price":4000},{"id":42111584632914,"title":"Self Adhesive / Custom Roll","option1":"Self Adhesive","option2":"Custom Roll","price":9500}];
//           var variantsIdSelected = fc_variant_price[0]?.id;
//         `;
//         document.body.appendChild(inlineScript);

//         // Load external calculator script
//         const externalScript = document.createElement("script");
//         externalScript.src = "https://cdn.shopify.com/extensions/31fb2947-9a15-47d8-bf6c-644ea8937ef1/price-calculator-79/assets/flooring.min.js";
//         externalScript.async = true;
//         document.body.appendChild(externalScript);
//       }

//       if (dimensionsNoteDiv) {
//         dimensionsNoteDiv.style.display = 'none'; // Hide when Custom Roll selected
//       }
//       // originalCalculatorContainer is hidden already above
//     }
//   }

//   if (customRollRadio && standardRollRadio) {
//     customRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     standardRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     insertCalculatorIfNeeded(); // Run once on load
//   }
// });

//with warning msg
// document.addEventListener("DOMContentLoaded", function () {
//   const customRollRadio = document.querySelector('input[value="Custom Roll"]');
//   const standardRollRadio = document.querySelector('input[value="Standard Roll"]');

//   const calculatorHTML = `
//     <div id="entangle_floor_calculator_container">
//       <div class="entangle-cal-flooring" id="entangle_floor_calculator" style="display: block;">
//         <div style="color: #000000; background-color: #ffffff; border-radius: 10px; padding:10px;">
//           <div class="entangle-lw-container" style="padding-block:10px;">
//             <div class="entangle-lw-calculator-inputs" style="justify-content: normal;">
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="length" id="sqFtInput-length" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Length">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Length</span>
//               </div>
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="width" id="sqFtInput-width" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Width">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Width</span>
//               </div>
//             </div>
//             <div class="entangle-pc-heading">
//               <div></div>
//               <svg viewBox="0 0 20 20" height="20px" width="20px" style="fill: #008000;" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true"><path fill-rule="evenodd" d="M10 7.25c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 1 1 3.758 2.56.61.61 0 0 0-.226.147.154.154 0 0 0-.032.046.75.75 0 0 1-1.5-.003c0-.865.696-1.385 1.208-1.586a1.25 1.25 0 0 0-.458-2.414Z"></path><path d="M10 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg>
//             </div>
//             <div style="display: flex;flex-direction: column;line-height: 1.5;">
//               <p id="entanglePerBoxCoverage" style="margin: 0; font-size: 14px; font-weight: 650;">Per Unit Coverage: 1 in²</p>
//               <p id="entangleTotalPrice" style="margin: 0; font-size: 14px; font-weight: 650; color: #008000;">Total Price: </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;

//   let calculatorInserted = false;
//   let warningMessage = null; // <---- keep reference to warning message

//   function insertCalculatorIfNeeded() {
//     const existingCalculator = document.querySelector('#entangle_floor_calculator_container');
//     const fieldset = customRollRadio?.closest('fieldset');
//     const dimensionsNoteDiv = document.querySelector('.dimensions-note');

//     const originalCalculatorContainer = document.querySelector('#entangle_floor_calculator_container:not(:empty):not([data-inserted])');

//     if (originalCalculatorContainer) {
//       originalCalculatorContainer.style.display = 'none';
//     }

//     if (standardRollRadio?.checked) {
//       if (existingCalculator) {
//         existingCalculator.remove();
//         calculatorInserted = false;
//       }
//       if (warningMessage) {
//         warningMessage.style.display = 'none'; // hide warning on standard roll
//       }
//       if (dimensionsNoteDiv) {
//         dimensionsNoteDiv.style.display = '';
//       }
//       return;
//     }

//     if (customRollRadio?.checked) {
//       if (fieldset && !calculatorInserted) {
//         const tempWrapper = document.createElement('div');
//         tempWrapper.innerHTML = calculatorHTML;
//         const calculatorDiv = tempWrapper.firstElementChild;
//         calculatorDiv.setAttribute('data-inserted', 'true');

//         // Create warning message element only once
//         if (!warningMessage) {
//           warningMessage = document.createElement('p');
//           warningMessage.style.color = '#d9534f';
//           warningMessage.style.fontSize = '17px';
//           warningMessage.style.fontWeight = '600';
//           warningMessage.style.marginBottom = '10px';
//           warningMessage.style.marginTop = '10px';
//           warningMessage.textContent = "Make sure that the minimum dimensions should be 50 × 50. Otherwise, the order would not be accepted.";
//           fieldset.insertAdjacentElement('afterend', warningMessage);
//         }

//         warningMessage.style.display = 'block'; // show warning
//         warningMessage.insertAdjacentElement('afterend', calculatorDiv);

//         calculatorInserted = true;

//         const inlineScript = document.createElement("script");
//         inlineScript.textContent = `
//           const api_url = '/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/7468741427282';
//           let productHandle = 'windsor-scroll-damask-wallpaper';
//           let product_price;
//           let fc_variant_price = [{"id":42086459605074,"title":"Canvas / Standard Roll","option1":"Canvas","option2":"Standard Roll","price":3000},{"id":42111584600146,"title":"Canvas / Custom Roll","option1":"Canvas","option2":"Custom Roll","price":9500},{"id":42086459637842,"title":"Self Adhesive / Standard Roll","option1":"Self Adhesive","option2":"Standard Roll","price":4000},{"id":42111584632914,"title":"Self Adhesive / Custom Roll","option1":"Self Adhesive","option2":"Custom Roll","price":9500}];
//           var variantsIdSelected = fc_variant_price[0]?.id;
//         `;
//         document.body.appendChild(inlineScript);

//         const externalScript = document.createElement("script");
//         externalScript.src = "https://cdn.shopify.com/extensions/31fb2947-9a15-47d8-bf6c-644ea8937ef1/price-calculator-79/assets/flooring.min.js";
//         externalScript.async = true;
//         document.body.appendChild(externalScript);
//       }
//       if (dimensionsNoteDiv) {
//         dimensionsNoteDiv.style.display = 'none';
//       }
//     }
//   }

//   if (customRollRadio && standardRollRadio) {
//     customRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     standardRollRadio.addEventListener('change', insertCalculatorIfNeeded);
//     insertCalculatorIfNeeded();
//   }
// });

//Script to show the calculator only when custom roll is the option

//without warning msg
// document.addEventListener("DOMContentLoaded", function () {
//   // Calculator HTML block
//   const calculatorHTML = `
//     <div id="entangle_floor_calculator_container" style="margin-top: 10px;">
//       <div class="entangle-cal-flooring" id="entangle_floor_calculator" style="display: block;">
//         <div style="color: #000000; background-color: #ffffff; border-radius: 10px; padding:10px;">
//           <div class="entangle-lw-container" style="padding-block:10px;">
//             <div class="entangle-lw-calculator-inputs" style="justify-content: normal;">
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="length" id="sqFtInput-length" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Length">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Length</span>
//               </div>
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="width" id="sqFtInput-width" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Width">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Width</span>
//               </div>
//             </div>
//             <div class="entangle-pc-heading">
//               <div></div>
//               <svg viewBox="0 0 20 20" height="20px" width="20px" style="fill: #008000;" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
//                 <path fill-rule="evenodd" d="M10 7.25c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 1 1 3.758 2.56.61.61 0 0 0-.226.147.154.154 0 0 0-.032.046.75.75 0 0 1-1.5-.003c0-.865.696-1.385 1.208-1.586a1.25 1.25 0 0 0-.458-2.414Z"></path>
//                 <path d="M10 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
//                 <path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path>
//               </svg>
//             </div>
//             <div style="display: flex;flex-direction: column;line-height: 1.5;">
//               <p id="entanglePerBoxCoverage" style="margin: 0; font-size: 14px; font-weight: 650;">Per Unit Coverage: 1 in²</p>
//               <p id="entangleTotalPrice" style="margin: 0; font-size: 14px; font-weight: 650; color: #008000;">Total Price: </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;

//   let scriptsInjected = false;

//   // Function to insert the calculator only if Custom Roll is the only option
//   function insertCalculator() {
//     const allRadioInputs = document.querySelectorAll('input[type="radio"]');
//     const customRollRadio = Array.from(allRadioInputs).find(input => input.value === "Custom Roll");
//     const standardRollRadio = Array.from(allRadioInputs).find(input => input.value === "Standard Roll");

//     // Exit if Custom Roll is not found or Standard Roll is also present
//     if (!customRollRadio || standardRollRadio) return;

//     // Check if calculator already exists
//     if (document.querySelector('#entangle_floor_calculator_container')) return;

//     // Find the closest container to insert the calculator
//     const customRollFieldset = customRollRadio.closest('fieldset') || customRollRadio.closest('.selector-wrapper');
//     if (!customRollFieldset) return;

//     const tempWrapper = document.createElement('div');
//     tempWrapper.innerHTML = calculatorHTML;
//     const calculatorDiv = tempWrapper.firstElementChild;

//     // Insert the calculator after the customRoll section
//     customRollFieldset.insertAdjacentElement('afterend', calculatorDiv);

//     // Inject scripts once
//     if (!scriptsInjected) {
//       const inlineScript = document.createElement("script");
//       inlineScript.textContent = `
//         const api_url = '/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/7468741427282';
//         let productHandle = 'windsor-scroll-damask-wallpaper';
//         let product_price;
//         let fc_variant_price = [{"id":42086459605074,"title":"Canvas / Standard Roll","option1":"Canvas","option2":"Standard Roll","price":3000},{"id":42111584600146,"title":"Canvas / Custom Roll","option1":"Canvas","option2":"Custom Roll","price":9500},{"id":42086459637842,"title":"Self Adhesive / Standard Roll","option1":"Self Adhesive","option2":"Standard Roll","price":4000},{"id":42111584632914,"title":"Self Adhesive / Custom Roll","option1":"Self Adhesive","option2":"Custom Roll","price":9500}];
//         var variantsIdSelected = fc_variant_price[0]?.id;
//       `;
//       document.body.appendChild(inlineScript);

//       const externalScript = document.createElement("script");
//       externalScript.src = "https://cdn.shopify.com/extensions/31fb2947-9a15-47d8-bf6c-644ea8937ef1/price-calculator-79/assets/flooring.min.js";
//       externalScript.async = true;
//       document.body.appendChild(externalScript);

//       scriptsInjected = true;
//     }
//   }

//   // Initial call on page load
//   insertCalculator();

//   // Observe DOM changes to dynamically insert calculator
//   const productFormContainer = document.querySelector('.product-form__item') || document.body;
//   if (productFormContainer) {
//     const observer = new MutationObserver(() => {
//       insertCalculator();
//     });

//     observer.observe(productFormContainer, {
//       childList: true,
//       subtree: true,
//     });
//   }
// });

//with warning msg
// document.addEventListener("DOMContentLoaded", function () {
//   const calculatorHTML = `
//     <div id="entangle_floor_calculator_container" style="margin-top: 10px;">
//       <div class="entangle-cal-flooring" id="entangle_floor_calculator" style="display: block;">
//         <div style="color: #000000; background-color: #ffffff; border-radius: 10px; padding:10px;">
//           <div class="entangle-lw-container" style="padding-block:10px;">
//             <div class="entangle-lw-calculator-inputs" style="justify-content: normal;">
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="length" id="sqFtInput-length" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Length">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Length</span>
//               </div>
//               <div class="entangle-lw-input-group" style="width: 100%; border-radius: 0px; border: 1px solid #cccccc; outline: none;">
//                 <input type="number" name="width" id="sqFtInput-width" class="entangle-lw-input-field" style="background: white; color: #000000;" min="0" placeholder="Enter Width">
//                 <span class="entangle-lw-input-label" style="background-color: #ffffff; color: #000000;">Width</span>
//               </div>
//             </div>
//             <div class="entangle-pc-heading">
//               <div></div>
//               <svg viewBox="0 0 20 20" height="20px" width="20px" style="fill: #008000;" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
//                 <path fill-rule="evenodd" d="M10 7.25c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0 2.75 2.75 0 1 1 3.758 2.56.61.61 0 0 0-.226.147.154.154 0 0 0-.032.046.75.75 0 0 1-1.5-.003c0-.865.696-1.385 1.208-1.586a1.25 1.25 0 0 0-.458-2.414Z"></path>
//                 <path d="M10 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
//                 <path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path>
//               </svg>
//             </div>
//             <div style="display: flex;flex-direction: column;line-height: 1.5;">
//               <p id="entanglePerBoxCoverage" style="margin: 0; font-size: 14px; font-weight: 650;">Per Unit Coverage: 1 in²</p>
//               <p id="entangleTotalPrice" style="margin: 0; font-size: 14px; font-weight: 650; color: #008000;">Total Price: </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   `;

//   const minimumDimensionsNote = `
//     <div id="minimum-dimensions-note" style="margin-bottom: 10px; margin-top: 10px; font-weight: 600; color: #d9534f;">
//       Make sure that the minimum dimensions should be 50 × 50. Otherwise, the order would not be accepted.
//     </div>
//   `;

//   let scriptsInjected = false;

//   function insertCalculator() {
//     const allRadioInputs = document.querySelectorAll('input[type="radio"]');
//     const customRollRadio = Array.from(allRadioInputs).find(input => input.value === "Custom Roll");
//     const standardRollRadio = Array.from(allRadioInputs).find(input => input.value === "Standard Roll");

//     if (!customRollRadio || standardRollRadio) return;
//     if (document.querySelector('#entangle_floor_calculator_container')) return;

//     const customRollFieldset = customRollRadio.closest('fieldset') || customRollRadio.closest('.selector-wrapper');
//     if (!customRollFieldset) return;

//     // Create wrapper for both note and calculator
//     const wrapperDiv = document.createElement('div');
//     wrapperDiv.innerHTML = minimumDimensionsNote + calculatorHTML;

//     // Insert both above
//     customRollFieldset.insertAdjacentElement('afterend', wrapperDiv);

//     // Inject external scripts only once
//     if (!scriptsInjected) {
//       const inlineScript = document.createElement("script");
//       inlineScript.textContent = `
//         const api_url = '/apps/fc-calculator-setting/products/extension?shopify_product_id=gid://shopify/Product/7468741427282';
//         let productHandle = 'windsor-scroll-damask-wallpaper';
//         let product_price;
//         let fc_variant_price = [{"id":42086459605074,"title":"Canvas / Standard Roll","option1":"Canvas","option2":"Standard Roll","price":3000},{"id":42111584600146,"title":"Canvas / Custom Roll","option1":"Canvas","option2":"Custom Roll","price":9500},{"id":42086459637842,"title":"Self Adhesive / Standard Roll","option1":"Self Adhesive","option2":"Standard Roll","price":4000},{"id":42111584632914,"title":"Self Adhesive / Custom Roll","option1":"Self Adhesive","option2":"Custom Roll","price":9500}];
//         var variantsIdSelected = fc_variant_price[0]?.id;
//       `;
//       document.body.appendChild(inlineScript);

//       const externalScript = document.createElement("script");
//       externalScript.src = "https://cdn.shopify.com/extensions/31fb2947-9a15-47d8-bf6c-644ea8937ef1/price-calculator-79/assets/flooring.min.js";
//       externalScript.async = true;
//       document.body.appendChild(externalScript);

//       scriptsInjected = true;
//     }
//   }

//   insertCalculator();

//   const productFormContainer = document.querySelector('.product-form__item') || document.body;
//   if (productFormContainer) {
//     const observer = new MutationObserver(() => {
//       insertCalculator();
//     });

//     observer.observe(productFormContainer, {
//       childList: true,
//       subtree: true,
//     });
//   }
// });


// document.addEventListener("DOMContentLoaded", function () {

//   const calculatorBlock = document.querySelector('.shopify-app-block');
//   const rollWrapper = document.querySelector('fieldset[name="roll-size"]');
//   const dimensionsNote = document.querySelector('.dimensions-note');

//   if (!calculatorBlock || !rollWrapper) return;

//   // 1️⃣ Move calculator under Roll Size fieldset
//   rollWrapper.parentElement.insertAdjacentElement('afterend', calculatorBlock);

//   function isCustomSelected() {
//     const checked = rollWrapper.querySelector('input[type="radio"]:checked');
//     return checked && checked.value === "Custom Roll";
//   }

//   function toggleCalculator() {
//     if (isCustomSelected()) {
//       calculatorBlock.style.display = "block";
//       if (dimensionsNote) dimensionsNote.style.display = "none";
//     } else {
//       calculatorBlock.style.display = "none";
//       if (dimensionsNote) dimensionsNote.style.display = "block";
//     }
//   }

//   // 2️⃣ Initial check
//   toggleCalculator();

//   // 3️⃣ Listen for roll size change
//   rollWrapper.addEventListener("change", function (e) {
//     if (e.target.type === "radio") {
//       toggleCalculator();
//     }
//   });

// });



document.addEventListener("DOMContentLoaded", function () {

  const calculatorBlock = document.querySelector('.shopify-app-block');
  const rollFieldset = document.querySelector('fieldset[name="roll-size"]');

  if (!calculatorBlock || !rollFieldset) return;

  // Move calculator under Roll Size section
  rollFieldset.parentElement.insertAdjacentElement('afterend', calculatorBlock);

  // ---------- Create Warning Message ----------
  let warningMsg = document.createElement("div");
  warningMsg.id = "custom-roll-warning";
  warningMsg.style.cssText = `
      color:#d9534f;
      font-weight:600;
      font-size:16px;
      margin-top:10px;
  `;
  warningMsg.innerText = "Make sure the dimensions should be 50 × 50";

  calculatorBlock.parentElement.insertBefore(warningMsg, calculatorBlock);

  // ---------- Create Standard Roll Message ----------
  let standardMsg = document.createElement("div");
  standardMsg.id = "standard-roll-dimension";
  standardMsg.style.cssText = `
      font-size:16px;
      color:#555;
      margin-top:8px;
  `;
  standardMsg.innerText = "";

  rollFieldset.parentElement.appendChild(standardMsg);

  function isCustomSelected() {
      const checked = rollFieldset.querySelector('input[type="radio"]:checked');
      return checked && checked.value === "Custom Roll";
  }

  function toggleUI() {
      if (isCustomSelected()) {
          calculatorBlock.style.display = "block";
          warningMsg.style.display = "block";
          standardMsg.style.display = "none";
      } else {
          calculatorBlock.style.display = "none";
          warningMsg.style.display = "none";
          standardMsg.style.display = "block";
      }
  }

  // Initial check
  toggleUI();

  // Listen for roll size change
  rollFieldset.addEventListener("change", function(e){
      if (e.target.type === "radio") {
          toggleUI();
      }
  });

});

//Script For adding a custom div under standard role variant on single product page

// document.addEventListener("DOMContentLoaded", function () {
//   // Find all selector wrappers
//   const wrappers = document.querySelectorAll(".selector-wrapper");

//   wrappers.forEach(wrapper => {
//     const label = wrapper.querySelector("label span.st-tooltip__content");
//     const fieldset = wrapper.querySelector("fieldset");

//     // Remove any existing dimensions note first
//     const existingNote = wrapper.querySelector(".dimensions-note");
//     if (existingNote) {
//       existingNote.remove();
//     }

//     // If Standard Roll is selected, show the note
//     if (label && label.textContent.trim() === "Standard Roll" && fieldset) {
//       const note = document.createElement("div");
//       note.className = "dimensions-note";
//       note.textContent = "Dimensions: 57 sq ft";
//       note.style.fontSize = "16px";
//       note.style.color = "#555";
//       note.style.marginTop = "5px";

//       fieldset.insertAdjacentElement("afterend", note);
//     }
//   });
// });

// Global function to capture scene selections
// window.selectionChanged = function (param) {
//   if (param.type === "material") {
//     console.log("Material selected:");
//     console.log(" - Material:", param.material);
//     console.log(" - SKU:", param.sku);
//     console.log(" - Object:", param.option); 
//     console.log(" - Mesh:", param.mesh); 
//     console.log(" - Scene:", param.sceneName);     
//   } 
//   else if (param.type === "mesh") {
//     console.log("Mesh selected:");
//     console.log(" - Mesh:", param.mesh);
//     console.log(" - Object:", param.option);
//     console.log(" - Scene:", param.sceneName); 
//   }
// };

// window.selectionChanged = async function (param) {
//   if (param.type === "material") {
//     const sku = param.sku;
//     console.log("Material selected:");
//     console.log(" - Material:", param.material);
//     console.log(" - SKU:", sku);
//     console.log(" - Object:", param.option); 
//     console.log(" - Mesh:", param.mesh); 
//     console.log(" - Scene:", param.sceneName);     

//     // Call Shopify to find the product by SKU
//     try {
//       const product = await fetchProductBySKU(sku);
//       if (product) {
//         console.log("✅ Product matched:");
//         console.log(product);
//       } else {
//         console.log("❌ No matching product found in Shopify for SKU:", sku);
//       }
//     } catch (err) {
//       console.error("Error while fetching product from Shopify:", err);
//     }
//   } 
//   else if (param.type === "mesh") {
//     console.log("Mesh selected:");
//     console.log(" - Mesh:", param.mesh);
//     console.log(" - Object:", param.option);
//     console.log(" - Scene:", param.sceneName); 
//   }
// };

// async function fetchProductBySKU(targetSku) {
//   const query = `
//     query {
//       products(first: 100) {
//         edges {
//           node {
//             title
//             handle
//             variants(first: 10) {
//               edges {
//                 node {
//                   title
//                   sku
//                   availableForSale
//                   quantityAvailable
//                   price {
//                     amount
//                     currencyCode
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   `;

//   const response = await fetch("https://bukumw-0e.myshopify.com/api/2023-10/graphql.json", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "X-Shopify-Storefront-Access-Token": "YOUR_TOKEN_HERE"
//     },
//     body: JSON.stringify({ query })
//   });

//   const json = await response.json();
//   const products = json?.data?.products?.edges || [];

//   for (const product of products) {
//     const variants = product.node.variants.edges;
//     for (const variantEdge of variants) {
//       const variant = variantEdge.node;
//       const variantSku = variant.sku?.trim().toLowerCase();
//       const incomingSku = targetSku.trim().toLowerCase();

//       console.log("Checking variant SKU:", variantSku, "against target SKU:", incomingSku);

//       if (variantSku === incomingSku) {
//         return {
//           productTitle: product.node.title,
//           handle: product.node.handle,
//           ...variant
//         };
//       }
//     }
//   }

//   return null; // Not found
// }


// current one
// window.selectionChanged = async function (param) {
//   if (param.type === "material") {
//     const sku = param.sku;
//     console.log("🧩 Material selected:");
//     console.log(" - Material:", param.material);
//     console.log(" - SKU:", sku);
//     console.log(" - Object:", param.option); 
//     console.log(" - Mesh:", param.mesh); 
//     console.log(" - Scene:", param.sceneName);     

//     // Fetch product using custom metafield `sku2`
//     try {
//       const product = await fetchProductBySKU2(sku);
//       if (product) {
//         console.log("✅ Product matched using metafield sku2:");
//         console.log(product);
//       } else {
//         console.log("❌ No product matched for sku2:", sku);
//       }
//     } catch (error) {
//       console.error("🔥 Error fetching product from Shopify:", error);
//     }
//   } 
//   else if (param.type === "mesh") {
//     console.log("🧱 Mesh selected:");
//     console.log(" - Mesh:", param.mesh);
//     console.log(" - Object:", param.option);
//     console.log(" - Scene:", param.sceneName); 
//   }
// };

// async function fetchProductBySKU2(targetSku) {
//   const query = `
//     query {
//       products(first: 100) {
//         edges {
//           node {
//             title
//             handle
//             metafield(namespace: "custom", key: "sku2") {
//               value
//             }
//             variants(first: 1) {
//               edges {
//                 node {
//                   title
//                   availableForSale
//                   price {
//                     amount
//                     currencyCode
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     }
//   `;

//   const response = await fetch("https://bukumw-0e.myshopify.com/api/2023-10/graphql.json", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       "X-Shopify-Storefront-Access-Token": "0c50e696ba9a2a96721f623af2d35510"
//     },
//     body: JSON.stringify({ query })
//   });

//   const json = await response.json();

//   const products = json?.data?.products?.edges || [];

//   for (const productEdge of products) {
//     const product = productEdge.node;
//     const metafieldValue = product?.metafield?.value?.trim()?.toLowerCase();
//     const inputSku = targetSku.trim().toLowerCase();

//     // console.log("🔍 Comparing SKU:", inputSku, "with sku2 metafield:", metafieldValue);

//     if (metafieldValue === inputSku) {
//       const variant = product.variants.edges[0]?.node;
//       return {
//         title: product.title,
//         handle: product.handle,
//         variantTitle: variant?.title,
//         price: variant?.price,
//         availableForSale: variant?.availableForSale
//       };
//     }
//   }

//   return null; // Not found
// }

// ✅ Listen for selection change in 3D viewer
window.selectionChanged = async function (param) {
  if (param.type === "material") {
    const sku = param.sku;
    console.log("🧩 Material selected:");
    console.log(" - Material:", param.material);
    console.log(" - SKU:", sku);
    console.log(" - Object:", param.option); 
    console.log(" - Mesh:", param.mesh); 
    console.log(" - Scene:", param.sceneName);     

    // Fetch product using custom metafield `sku2`
    try {
      const product = await fetchProductBySKU2(sku);
      if (product) {
        console.log("✅ Product matched using metafield sku2:");
        console.log(product);

        // 👉 Show popup on the page
        showProductPopup(product);
      } else {
        console.log("❌ No product matched for sku2:", sku);
      }
    } catch (error) {
      console.error("🔥 Error fetching product from Shopify:", error);
    }
  } 
  else if (param.type === "mesh") {
    console.log("🧱 Mesh selected:");
    console.log(" - Mesh:", param.mesh);
    console.log(" - Object:", param.option);
    console.log(" - Scene:", param.sceneName); 
  }
};

// ✅ Function to fetch product by metafield sku2
async function fetchProductBySKU2(targetSku) {
  const query = `
    query {
      products(first: 100) {
        edges {
          node {
            id
            title
            handle
            featuredImage {
              url
              altText
            }
            metafield(namespace: "custom", key: "sku2") {
              value
            }
            variants(first: 20) {
              edges {
                node {
                  id  
                  title
                  availableForSale
                  price {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const response = await fetch("https://oneloom.in/api/2023-10/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "0c50e696ba9a2a96721f623af2d35510"
    },
    body: JSON.stringify({ query })
  });

  const json = await response.json();

  const products = json?.data?.products?.edges || [];

  for (const productEdge of products) {
    const product = productEdge.node;
    const variants = product.variants.edges.map(v => v.node);
    const optionsMap = {};
    variants.forEach(variant => {
      variant.selectedOptions.forEach(opt => {
        if (!optionsMap[opt.name]) optionsMap[opt.name] = new Set();
        optionsMap[opt.name].add(opt.value);
      });
    });

    // Convert sets to arrays for easier use
    const productOptions = Object.entries(optionsMap).map(([name, values]) => ({
      name,
      values: Array.from(values)
    }));

    const metafieldValue = product?.metafield?.value?.trim()?.toLowerCase();
    const inputSku = targetSku.trim().toLowerCase();

    if (metafieldValue === inputSku) {
      const variant = product.variants.edges[0]?.node;
      return {
        id: product.id,
        title: product.title,
        handle: product.handle,
        featuredImage: product.featuredImage ? {
          url: product.featuredImage.url,
          altText: product.featuredImage.altText
        } : null,
        // variantTitle: variant?.title,
        // price: variant?.price,
        // availableForSale: variant?.availableForSale,
        variants,
        options: productOptions,
        metafield: product.metafield
      };
    }
  }

  return null; // Not found
}


// ✅ Function to show popup on the page
function showProductPopup(product) {
  const popup = document.getElementById("product-popup");
  const optionsContainer = document.getElementById("popup-variant-options");
  const priceElement = document.getElementById("popup-price");

  // Update content
  document.getElementById("popup-title").innerText = product.title;
  
  optionsContainer.innerHTML = "";
    // 🔹 Create dropdowns for each option set (like Size, Color)
  if (product.options && product.options.length > 0) {
    product.options.forEach(opt => {
      const label = document.createElement("label");
      label.textContent = opt.name;
      label.style.display = "block";
      label.style.fontWeight = "bold";
      label.style.marginTop = "8px";

      const select = document.createElement("select");
      select.className = "variant-select";
      select.style.marginBottom = "10px";

      opt.values.forEach(value => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });

      optionsContainer.appendChild(label);
      optionsContainer.appendChild(select);
    });
  }

    // Default price
  const firstVariant = product.variants[0];
  priceElement.innerText = "Rs " + firstVariant.price.amount;

   // 🔹 Show variants
  // const variantsContainer = document.getElementById("popup-variants");
  // variantsContainer.innerHTML = "";
  //  if (product.variants && product.variants.length > 0) {
  //   product.variants.forEach(variant => {
  //     const div = document.createElement("div");
  //     div.className = "variant-item";
  //     div.innerText = `${variant.title} — Rs ${variant.price.amount}`;
  //     if (!variant.availableForSale) div.classList.add("sold-out");
  //     variantsContainer.appendChild(div);
  //   });
  // } else {
  //   variantsContainer.innerHTML = "<p>No variants available</p>";
  // }

  // document.getElementById("popup-price").innerText = "Rs " + (product.price ? product.price.amount : "N/A");
  document.getElementById("popup-link").href = `/products/${product.handle}`;

  const imgElement = document.getElementById("popup-image");
  if (product.featuredImage?.url) {
    imgElement.src = product.featuredImage.url;
    imgElement.alt = product.featuredImage.altText || product.title;
    imgElement.style.display = "block";
  } else {
    imgElement.style.display = "none";
  }

  popup.dataset.sku = product.metafield?.value || "";
  window.currentPopupProduct = product; 
  // 🔹 Console log to check SKU
  console.log("🌟 Product popup shown with SKU:", popup.dataset.sku);

  // Slide in popup
  popup.classList.add("show");
}

// Close button handler
document.getElementById("popup-close").addEventListener("click", () => {
  document.getElementById("product-popup").classList.remove("show");
});



// document.getElementById("popup-add-to-cart").addEventListener("click", async () => {
//   const popup = document.getElementById("product-popup");
//   const addToCartBtn = document.getElementById("popup-add-to-cart");

//   const selects = popup.querySelectorAll(".variant-select");
//   const selectedOptions = Array.from(selects).map(select => select.value);

//   const product = window.currentPopupProduct;
//   if (!product) return;

//   const matchedVariant = product.variants.find(v =>
//     v.selectedOptions.every(opt => selectedOptions.includes(opt.value))
//   );

//   if (!matchedVariant) {
//     alert("Please select a valid variant combination.");
//     return;
//   }

//   console.log("🧩 Selected Options:", selectedOptions);
//   console.log("🧩 Product Variants:", product.variants);
//   console.log("🧩 Matched Variant:", matchedVariant);

//   // 🔹 Convert GID → numeric ID
//   const numericVariantId = matchedVariant.id.split("/").pop();

//   const data = {
//     items: [
//       {
//         id: numericVariantId,
//         quantity: 1
//       }
//     ]
//   };

//   addToCartBtn.textContent = "Adding...";
//   addToCartBtn.disabled = true;

//   try {
//     const response = await fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) throw new Error("Failed to add to cart");
//     const result = await response.json();
//     console.log("🛒 Added to cart:", result);

//     addToCartBtn.textContent = "Added";
//     addToCartBtn.classList.add("added");

//     window.location.reload();

//     // Trigger cart icon click to refresh cart UI
//     const cartIcon = document.querySelector(".js-toggle-cart");
//     if (cartIcon) {
//       cartIcon.click();
//     }
//   } catch (error) {
//     console.error("Error adding to cart:", error);
//     addToCartBtn.textContent = "Add to Cart";
//   } finally {
//     addToCartBtn.disabled = false;
//   }
// });

document.getElementById("popup-add-to-cart").addEventListener("click", async () => {
  const addToCartBtn = document.getElementById("popup-add-to-cart");
  const popup = document.getElementById("product-popup");

  const selects = popup.querySelectorAll(".variant-select");
  const selectedOptions = Array.from(selects).map(select => select.value);

  const product = window.currentPopupProduct;
  if (!product) return;

  const matchedVariant = product.variants.find(v =>
    v.selectedOptions.every(opt => selectedOptions.includes(opt.value))
  );

  if (!matchedVariant) {
    alert("Please select a valid variant combination.");
    return;
  }

  const numericVariantId = matchedVariant.id.split("/").pop();

  const data = {
    items: [{ id: numericVariantId, quantity: 1 }]
  };

  addToCartBtn.textContent = "Adding...";
  addToCartBtn.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    if (!response.ok) throw new Error("Failed to add to cart");
    const result = await response.json();
    console.log("🛒 Added to cart:", result);

    // ✅ Store flag in sessionStorage to open cart after reload
    sessionStorage.setItem('openCartAfterReload', 'true');

    // Reload the page
    window.location.reload();

  } catch (error) {
    console.error("Error adding to cart:", error);
    addToCartBtn.textContent = "Add to Cart";
  } finally {
    addToCartBtn.disabled = false;
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const shouldOpenCart = sessionStorage.getItem('openCartAfterReload');
  if (shouldOpenCart === 'true') {
    const cartIcon = document.querySelector('.js-toggle-cart');
    if (cartIcon) cartIcon.click(); // trigger cart open
    sessionStorage.removeItem('openCartAfterReload'); // clear flag
  }
});



// function updateMiniCart(cart) {
//   const container = document.getElementById("mini-cart-items"); // your sidebar container
//   if (!container) return;

//   container.innerHTML = ""; // clear previous items

//   cart.items.forEach(item => {
//     const li = document.createElement("li");
//     li.textContent = `${item.quantity} × ${item.title} (${item.variant_title}) - Rs ${item.price / 100}`;
//     container.appendChild(li);
//   });

//   const totalEl = document.getElementById("mini-cart-total");
//   if (totalEl) totalEl.textContent = `Total: Rs ${cart.total_price / 100}`;
// }


// document.addEventListener('DOMContentLoaded', () => {
//   const popup = document.getElementById('bundle-popup');
//   const overlay = document.getElementById('bundle-overlay');
//   const popup2 = document.getElementById("product-popup");
//   // Map product SKU → bundle ID
//   const productSkuToBundleId = {
//     "WP0107": 709579,
//     "WP0106": 709579,
//     "WP0108": 709579,
//     "WP0102": 714795,
//     "WP0101": 714795,
//     "WP0104": 714795,
//     // add all your SKUs and bundle IDs here
//   };

//   // Button click listener
//   document.querySelectorAll('.popup-btn').forEach(btn => {
//     btn.addEventListener('click', e => {
//       e.preventDefault();

//       // Get SKU from clicked button
//       const sku = popup2.dataset.sku?.trim();
//       if (!sku) return alert('SKU missing on this button!');

//       const bundleId = productSkuToBundleId[sku];
//       console.log(bundleId);
//       if (!bundleId) return alert('No bundle found for this SKU.');

//       // Hide all bundles
//       document.querySelectorAll('.bundle').forEach(b => b.classList.remove('active'));

//       // Show only the matching bundle
//       const bundleEl = document.querySelector(`.bundle[data-bundle-id="${bundleId}"]`);
//       console.log(bundleEl);
//       if (bundleEl) bundleEl.classList.add('active');

//       // Show popup and overlay
//       popup.classList.add('active');
//       overlay.classList.add('active');
//     });
//   });

//   // Close popup on overlay click
//   overlay.addEventListener('click', () => {
//     popup.classList.remove('active');
//     overlay.classList.remove('active');
//   });
// });
